import { Url } from '../shared/Url';
import Post from '../shared/Post';
import PostXls from '../shared/PostXls';
import { cookieData } from '../funciones/ConsultaUser';

export const CuotasDisp = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
        }

        Post(`${Url}cuotas`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data[0])
        });
    });
}

export const CuotasDispSelect = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
        }

        Post(`${Url}cuotasSelect`, Content, (resp) => {
            let data = JSON.parse(resp)
            let contenido = []
            
            for (let i in data[0]) {
                contenido.push({
                    value: data[0][i].value, label: data[0][i].label
                })
            }
            respuesta (contenido)
        });
    });
}

export const CarrerasDisp = (respuesta) => {
    Post(`${Url}consultCarreras`, "", (resp) => {
        let data = JSON.parse(resp);

        let contenido = [
            { value: "todos", label: "APLICAR A TODOS" }
        ]
        
        for (let i in data[0]) {
            contenido.push({
                value: data[0][i].id, label: `APLICAR A ${data[0][i].carrera_name}`
            })
        }
        respuesta (contenido)
    });
}

export const CarrerasDisp2 = (respuesta) => {
    Post(`${Url}consultSeccionesGral`, "", (resp) => {
        let data = JSON.parse(resp);

        let contenido = []
        
        for (let i in data[0]) {
            contenido.push({
                value: data[0][i].id, label: `CERRAR ${data[0][i].materia_name}`
            })
        }
        respuesta (contenido)
    });
}

export const SeccionesDisp2 = (periodo, respuesta) => {
    let Content = {
        periodo: periodo,
    }

    Post(`${Url}seccionesDisp2`, Content, (resp) => {
        let data = JSON.parse(resp);

        let contenido = []
        
        for (let i in data[0]) {
            contenido.push({
                value: data[0][i].id, label: `CERRAR ${data[0][i].materia_name}`
            })
        }
        respuesta (contenido)
    });
}

export const EstDisp = (cuota, aplicarA, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            cuota: cuota,
            aplicar: aplicarA
        }
        Post(`${Url}EstDisp`, Content, (resp) => {
            let data = JSON.parse(resp)

            respuesta (data[0])
        });
    });
}

export const EstDispC = (cuota, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            cuota: cuota,
        }
        Post(`${Url}EstDispC`, Content, (resp) => {
            let data = JSON.parse(resp)

            respuesta (data[0])
        });
    });
}

export const CobrarCuota = (est, check, cuota, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            cuota: cuota.value,
            cuotaName: cuota.label,
            est: est,
            check: check
        }

        Post(`${Url}CobrarCuota`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta (data)
        });
    });
}

export const FinalizarCobro = (cuota, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            cuota: cuota
        }

        Post(`${Url}FInalizarCobro`, Content, (resp) => {
            respuesta(resp)
        });
    });
}

export const CantEstudiantesDeuda = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
        }

        Post(`${Url}cantEstudiantesDeuda`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data[0])
        });
    });
}

export const EstudiantesDeuda = (pagina, cantidad, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            pagina: pagina,
            cantidad: cantidad
        }

        Post(`${Url}EstudiantesDeuda`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data[0])
        });
    });
}

export const EstudiantesDeudaDat  = (pagina, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            pagina: pagina,
        }

        Post(`${Url}EstudiantesDeudaDat`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data)
        });
    });
}

export const FixDeuda  = (respuesta) => {

    Post(`${Url}FixDeuda`, "", (resp) => {
        let data = JSON.parse(resp)
        respuesta(data)
    });
}

export const EstDisponibles  = (respuesta) => {
    Post(`${Url}EstDisponiblesFix`, "", (resp) => {
        let data = JSON.parse(resp)
        respuesta(data)
    });
}

export const FixEstadoInd  = (est, respuesta) => {
    let Content = {
        idEst: est
    }

    Post(`${Url}FixEstadoInd`, Content, (resp) => {
        let data = JSON.parse(resp)
        respuesta(data)
    });
}

export const EliminarDec  = (est, respuesta) => {
    let Content = {
        idEst: est
    }

    Post(`${Url}EliminarDec`, Content, (resp) => {
        let data = JSON.parse(resp)
        respuesta(data)
    });
}

export const EstudiantesDeudaInd = (string, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            strings: string
        }

        Post(`${Url}EstudiantesDeudaInd`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data[0])
        });
    });
}

export const BusquedaEstInd = (string, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            strings: string
        }

        Post(`${Url}BusquedaEstInd`, Content, (resp) => {
            let data = JSON.parse(resp)

            respuesta(data[0])
        });
    });
}

export const DownloadXls = (tipo, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1]
        }

        if (tipo === "segmentado"){
            PostXls(`${Url}xlsEstadoHistorico`, Content, `Estado de Cuenta Histórico`, (resp) => {
                respuesta(resp)
            });
        }else{
            PostXls(`${Url}xlsEstadoHistoricoSF`, Content, `Estado de Cuenta Histórico - (Sin Formato)`, (resp) => {
                respuesta(resp)
            });
        } 
    });
}

export const ConsultAutoridad = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1]
        }

        Post(`${Url}ConsultAutoridad`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data[0])
        });
    });
}

export const CheckStatusDelT = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1]
        }

        Post(`${Url}ChkStatusDelT`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data[0])
        });
    });  
}

export const DelTrasaccion = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            tId: id
        }

        Post(`${Url}DelTrasaccion`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data)
        });
    });  
}

export const Reintegro = (campos, id, respuesta) => {
    let Content = ""
    cookieData((cookie) => {
        switch (campos.selectMetodos.value){
            case "Transferencia":
                Content = {
                    uId: cookie[1],
                    idEst: id,
                    monto: campos.monto,
                    referencia: campos.monto,
                    metodo: campos.selectMetodos.value,
                    observaciones: campos.observaciones
                }
            break
            case "Efectivo":
                Content = {
                    uId: cookie[1],
                    idEst: id,
                    monto: campos.monto,
                    metodo: campos.selectMetodos.value,
                    observaciones: campos.observaciones
                }
            break
            case "Divisa":
                Content = {
                    uId: cookie[1],
                    idEst: id,
                    monto: campos.monto,
                    cambio: campos.cambio,
                    metodo: campos.selectMetodos.value,
                    observaciones: campos.observaciones
                }
            break
        }

        

        Post(`${Url}Reintegro`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data)
        });
    });
}

export const ConsultaSecciones = (semestre, respuesta) => {
    let Content = {
        semestre: semestre
    }

    Post(`${Url}ConsultaSecciones`, Content, (resp) => {
        let data1 = JSON.parse(resp);
        let data = data1[0];
        let contenido= [];

        for (let i in data) {
            let romanos = ["I", "II", "III", "IV", "V", "VI","VII", "VIII", "IX", "X"];
            let semL = romanos[(data[i].semestre_num - 1)]
            /* let semL = "";
            let semN = data[i].semestre_num
            if (semN === 1) semL = "I";
            if (semN === 2) semL = "II";
            if (semN === 3) semL = "III";
            if (semN === 4) semL = "IV";
            if (semN === 5) semL = "V";
            if (semN === 6) semL = "VI";
            if (semN === 7) semL = "VII";
            if (semN === 8) semL = "VIII";
            if (semN === 9) semL = "IX";
            if (semN === 10) semL = "X";
            if (semN === 11) semL = "XI";
            if (semN === 12) semL = "XII"; */
            
            let datosSecc = {
                sem: semL,
                materia: data[i].materia_name,
                codigo: data[i].codigo,
                carrera: data[i].carrera_name,
                seccion: data[i].nombre
            }

            contenido.push(
                { value: data[i].id, label: `${data[i].materia_name} - ${data[i].nombre}`, datos: datosSecc }
            )
        }

        respuesta([contenido])
    });
}

export const EstudiantesDeudaSecc = (seccion, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            seccion: seccion
        }
        Post(`${Url}EstudiantesDeudaSecc`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data[0])
        });
    });
}

export const CortesDisp = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
        }
        Post(`${Url}CortesDisp`, Content, (resp) => {
            let data = JSON.parse(resp)
            let contenido= [];
            for (let i = 1; i <= data[0]; i++) {
                contenido.push(
                    { value: i, label: `Corte ${i}` }
                )
            }

            contenido.push(
                { value: 'all', label: "Todos los Cortes" }
            )

            respuesta(contenido)
        });
    });
}

export const EstSecc = (seccion, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            seccion: seccion
        }
        Post(`${Url}EstSecc`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data[0])
        });
    });
}

export const AllEstSecc = (corte, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            corte: corte
        }

        Post(`${Url}AllEstSecc`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data[0])
        });
    });
}

export const RetirarEst = (est, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            est: est
        }
        Post(`${Url}RetirarEst`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data[0])
        });
    });
}

export const SolicSolvencia = (est, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            idEst: est
        }

        Post(`${Url}SolicSolvencia`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data)
        });
    });
}


// WEBPACK FOOTER //
// ./src/funciones/CobranzasFunction.jsx